import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

import { RootState } from 'reducers';
import { printMerchantCardholderReceipts } from 'paymentIntegrations/utils';
import { CardPaymentHooks } from 'paymentIntegrations/types';

import { TransactionRequest } from '../types';

export const handleSuccess = ({
  payment,
  response,
  inputData,
  beforeDocDelete,
  beforeDocSave,
}: {
  beforeDocDelete: CardPaymentHooks['beforeDocDelete'];
  beforeDocSave: CardPaymentHooks['beforeDocSave'];
  payment: { [key: string]: any };
  inputData: TransactionRequest;
  response: any;
}) => async (dispatch: ThunkDispatch<RootState, unknown, Action>) => {
  if (inputData.transactionType === 'VOID') {
    await beforeDocDelete(payment.key);
  } else {
    const amount =
      inputData.transactionType === 'REFUND'
        ? `-${Number(response.approvedAmount).toFixed(2)}`
        : Number(response.approvedAmount).toFixed(2);
    // region AdditionalReceiptData saving to JSON API (CURRENTLY COMMENTED OUT)
    /* const additionalReceiptData: {
      cardholderPatchScript?: PatchScript;
      merchantPatchScript?: PatchScript;
    } = {};
    if (response.additionalData) {
      const { merchant, cardholder } = response.additionalData;
      if (cardholder) {
        additionalReceiptData.cardholderPatchScript = generatePatchscriptFromString(
          cardholder,
        );
      }
      if (merchant) {
        additionalReceiptData.merchantPatchScript = generatePatchscriptFromString(
          merchant,
        );
      }
    } */
    // endregion

    await beforeDocSave({
      ...payment,
      transactionId: response.referenceNumber,
      paymentType: response.paymentType,
      amount,
      attributes: {
        refNo: response.referenceNumber,
        authCode: response.authCode,
        hostReferenceNumber: response.hostReferenceNumber,
      },
      ...response,
      paid: true,
    });
    if (response.additionalData) {
      dispatch(printMerchantCardholderReceipts(response.additionalData));
    }
  }
};
